import { FC, useState } from 'react';
import { NudosButton, NudosTextArea } from '../../../../../../../components/NudosComponents';
import {
  AGENT_CHAT_FILTER_OPTIONS,
  AGENT_CHAT_FILTER_OPTIONS_LABELS
} from '../../../../../../../types/agentChat.types';
import './AgentChatInput.scss';

const AgentChatInput: FC<IAgentChatInput> = ({ handleSendMessage, isDisabled, isLoading }) => {
  const [question, setQuestion] = useState<string>('');
  const [questionFilter, setQuestionFilter] = useState<AGENT_CHAT_FILTER_OPTIONS>(AGENT_CHAT_FILTER_OPTIONS.DEFAULT);

  const agentChatFilterOptionsList = [
    { value: AGENT_CHAT_FILTER_OPTIONS.DEFAULT, label: AGENT_CHAT_FILTER_OPTIONS_LABELS.DEFAULT },
    { value: AGENT_CHAT_FILTER_OPTIONS.ORDER_COMMENTS, label: AGENT_CHAT_FILTER_OPTIONS_LABELS.ORDER_COMMENTS },
    { value: AGENT_CHAT_FILTER_OPTIONS.SERVICE_COMMENTS, label: AGENT_CHAT_FILTER_OPTIONS_LABELS.SERVICE_COMMENTS }
  ];

  const handleSubmit = () => {
    if (!question || isLoading || isDisabled) return;
    handleSendMessage(question.trim(), questionFilter);
    setQuestion('');
    setQuestionFilter(AGENT_CHAT_FILTER_OPTIONS.DEFAULT);
  };

  return (
    <div className={`agentChatInput ${isDisabled ? 'disabled' : ''}`}>
      <div className={`inputContainer ${question ? 'hasText' : ''}`}>
        <div className="filtersContainer">
          {agentChatFilterOptionsList.map(filter => (
            <button
              key={filter.value}
              type="button"
              onClick={() => setQuestionFilter(filter.value)}
              className={`filterButton ${questionFilter === filter.value ? 'active' : 'inactive'}`}
              disabled={isDisabled}
            >
              {filter.label}
            </button>
          ))}
        </div>
        <NudosTextArea
          currentValue={question}
          setCurrentValue={value => setQuestion(value)}
          maxLength={500}
          placeholder="Escribe una pregunta concreta, por ejemplo: “¿Qué ordenes siguen sin confirmarse en México?”"
          customClassName="textareaInput"
          isDeactivated={isDisabled}
          hidenCounter
          noResize
        />

        <div className="dividerLine" />

        {!question && (
          <div className="subtitleText">Sé específico en tus consultas para obtener mejores respuestas</div>
        )}

        {question && <div className="counterText">{`${question.length}/500`}</div>}
      </div>

      <NudosButton
        customClassName="sendButton"
        buttonText="Enviar"
        handleClick={() => handleSubmit()}
        isButtonDisabled={!question || isLoading || isDisabled}
      />
    </div>
  );
};

interface IAgentChatInput {
  handleSendMessage: (question: string, option: AGENT_CHAT_FILTER_OPTIONS) => void;
  isDisabled?: boolean;
  errorMessage?: string;
  isLoading?: boolean;
}

export default AgentChatInput;
